export enum ComplexEventCondition {
  /** And */
  And = 1,
  /** Or */
  Or = 2,
}
